module.exports = __webpack_public_path__ + "static/media/anne-laure-conversation-mobile.63e3e1bc.png";